import { useMemo, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { AgGridContextMenu } from "@components/ag_grid/AgGridContextMenu";

const HolidayPayReview = ({ holidayPayments }) => {
  // Context menu hook
  const { handleCellContextMenu, ContextMenuComponent } = AgGridContextMenu({});
  // Prevent default browser context menu
  const handleContextMenu = useCallback((event) => {
    event.preventDefault();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear().toString().slice(-2);
    return `${month}/${day}/${year}`;
  };

  const columnDefs = useMemo(
    () => [
      {
        headerName: "ID",
        field: "contractor_id",
        width: 100,
        filter: true,
      },
      {
        headerName: "Name",
        field: "name",
        width: 200,
        filter: true,
      },
      {
        headerName: "Date",
        field: "date",
        width: 130,
        filter: true,
        valueFormatter: (params) => formatDate(params.value),
      },
      {
        headerName: "Flat Amount",
        field: "flat_amount",
        width: 130,
        filter: true,
        valueFormatter: (params) =>
          params.value != null ? `$${params.value}` : "",
      },
      {
        headerName: "Gifted Hours",
        field: "gifted_hours",
        width: 130,
        filter: true,
      },
    ],
    []
  );

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      resizable: true,
    }),
    []
  );

  return (
    <div className="tw-bg-white tw-rounded-lg tw-border tw-border-gray-200 tw-p-4">
      <div
        className="ag-theme-balham tw-h-[73dvh] tw-w-full"
        onContextMenu={handleContextMenu}
      >
        <AgGridReact
          // className="ag-theme-balham"
          // domLayout="autoHeight"
          rowData={holidayPayments}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onCellContextMenu={handleCellContextMenu}
          // pagination={true}
          // paginationPageSize={15}
          animateRows={true}
        />
        {ContextMenuComponent}
      </div>
    </div>
  );
};

export default HolidayPayReview;
